"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.splitServiceFactory = void 0;
// Angular factory registration (mirrors list.service.ts style)
exports.splitServiceFactory = ['app.config', '$http', '$q', splitService];
function splitService(config, $http, $q) {
    var svc = {
        splitByBlankLines: splitByBlankLines,
        splitByDash: splitByDash,
        splitByBullets: splitByBullets,
    };
    return svc;
    function splitByBlankLines(id, keepFirst) {
        if (!id)
            return $q.reject('missing id');
        return $http
            .post(config.api, { action: 'splitByBlankLines', id: id, keepFirst: keepFirst ? 1 : 0 })
            .then(function (r) { return r; }, function (err) { return $q.reject(err); });
    }
    function splitByDash(id) {
        if (!id)
            return $q.reject('missing id');
        return $http
            .post(config.api, { action: 'splitByDash', id: id })
            .then(function (r) { return r; }, function (err) { return $q.reject(err); });
    }
    // Client-side bullet splitting (no server action yet) – posts each child as new note with parent linkage.
    function splitByBullets(parentRow, drafts) {
        if (!parentRow || !parentRow.ID)
            return $q.reject('missing parent');
        var created = [];
        var chain = drafts.reduce(function (p, d) {
            return p.then(function () {
                var auditRow = {
                    body: d.body,
                    pnParentFK: parentRow.ID,
                };
                if (d.taskGroup)
                    auditRow.taskGroup = d.taskGroup;
                if (d.topicGroup)
                    auditRow.topicGroup = d.topicGroup;
                if (d.topicDetail)
                    auditRow.topicDetail = d.topicDetail;
                return $http.post(config.api1, { action: 'auditRow', auditRow: auditRow }).then(function (r) {
                    var data = r && r.data ? r.data : {};
                    if (data && data.ID)
                        created.push(data.ID);
                });
            });
        }, $q.when());
        return chain.then(function () { return ({ Result: 'OK', Count: created.length, Created: created }); });
    }
}
